// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MinigameComponent = React.ComponentType<any>;

// Import individual template components from components folder
import Template01Investigation from './components/Template01Investigation';
import Template02Fingerprint from './components/Template02Fingerprint';
import Template03Cipher from './components/Template03Cipher';
import Template04Timeline from './components/Template04Timeline';
import Template05EvidenceBoard from './components/Template05EvidenceBoard';
import Template06Comparison from './components/Template06Comparison';
import Template07Contradiction from './components/Template07Contradiction';
import Template08Chase from './components/Template08Chase';
import Template09IntenseChase from './components/Template09IntenseChase';
import Template11ContradictionMatch from './components/Template11ContradictionMatch';
import Template12Interrogation from './components/Template12Interrogation';
import Template13Deduction from './components/Template13Deduction';
import Template14CipherV2 from './components/Template14CipherV2';
import Template15DoorSelection from './components/Template15DoorSelection';
import Template16ExistenceErosion from './components/Template16ExistenceErosion';
import Template17TimingEscape from './components/Template17TimingEscape';
import Template18HorrorQTE from './components/Template18HorrorQTE';
import Template19MrLiquid from './components/Template19MrLiquid';
import Template20SomaCallingFire from './components/Template20SomaCallingFire';

// Re-export with original naming convention for backwards compatibility
export const Minigame01_Investigation = Template01Investigation;
export const Minigame02_Fingerprint = Template02Fingerprint;
export const Minigame03_Cipher = Template03Cipher;
export const Minigame04_Timeline = Template04Timeline;
export const Minigame05_EvidenceBoard = Template05EvidenceBoard;
export const Minigame06_Comparison = Template06Comparison;
export const Minigame07_Contradiction = Template07Contradiction;
export const Minigame08_Chase = Template08Chase;
export const Minigame09_IntenseChase = Template09IntenseChase;
export const Minigame11_ContradictionMatch = Template11ContradictionMatch;
export const Minigame12_Interrogation = Template12Interrogation;
export const Minigame13_Deduction = Template13Deduction;
export const Minigame14_CipherV2 = Template14CipherV2;
export const Minigame15_DoorSelection = Template15DoorSelection;
export const Minigame16_ExistenceErosion = Template16ExistenceErosion;
export const Minigame17_TimingEscape = Template17TimingEscape;
export const Minigame18_HorrorQTE = Template18HorrorQTE;
export const Minigame19_MrLiquid = Template19MrLiquid;
export const Minigame20_SomaCallingFire = Template20SomaCallingFire;

// Also export with Template naming
export {
  Template01Investigation,
  Template02Fingerprint,
  Template03Cipher,
  Template04Timeline,
  Template05EvidenceBoard,
  Template06Comparison,
  Template07Contradiction,
  Template08Chase,
  Template09IntenseChase,
  Template11ContradictionMatch,
  Template12Interrogation,
  Template13Deduction,
  Template14CipherV2,
  Template15DoorSelection,
  Template16ExistenceErosion,
  Template17TimingEscape,
  Template18HorrorQTE,
  Template19MrLiquid,
  Template20SomaCallingFire
};

export const minigameComponents: Record<string, MinigameComponent> = {
  minigame_investigation_01: Minigame01_Investigation,
  minigame_fingerprint_02: Minigame02_Fingerprint,
  minigame_cipher_03: Minigame03_Cipher,
  minigame_timeline_04: Minigame04_Timeline,
  minigame_evidence_05: Minigame05_EvidenceBoard,
  minigame_comparison_06: Minigame06_Comparison,
  minigame_contradiction_07: Minigame07_Contradiction,
  minigame_chase_08: Minigame08_Chase,
  minigame_quickcipher_09: Minigame09_IntenseChase,
  minigame_contradiction_11: Minigame11_ContradictionMatch,
  minigame_interrogation_12: Minigame12_Interrogation,
  minigame_deduction_13: Minigame13_Deduction,
  minigame_cipherv2_14: Minigame14_CipherV2,
  minigame_doorselection_15: Minigame15_DoorSelection,
  minigame_existenceerosion_16: Minigame16_ExistenceErosion,
  minigame_timingescape_17: Minigame17_TimingEscape,
  minigame_horrorqte_18: Minigame18_HorrorQTE,
  minigame_mr_liquid_19: Minigame19_MrLiquid,
  minigame_soma_calling_fire_20: Minigame20_SomaCallingFire
};

export const minigameComponentsByTemplateId: Record<number, MinigameComponent> = {
  1: Minigame01_Investigation,
  2: Minigame02_Fingerprint,
  3: Minigame03_Cipher,
  4: Minigame04_Timeline,
  5: Minigame05_EvidenceBoard,
  6: Minigame06_Comparison,
  7: Minigame07_Contradiction,
  8: Minigame08_Chase,
  9: Minigame09_IntenseChase,
  11: Minigame11_ContradictionMatch,
  12: Minigame12_Interrogation,
  13: Minigame13_Deduction,
  14: Minigame14_CipherV2,
  15: Minigame15_DoorSelection,
  16: Minigame16_ExistenceErosion,
  17: Minigame17_TimingEscape,
  18: Minigame18_HorrorQTE,
  19: Minigame19_MrLiquid,
  20: Minigame20_SomaCallingFire
};
